import { NavBar } from "components/NavBar";
export const MainLayout = ({ children }) => (
  <>
    <NavBar />
    {children}
  </>
);
